module.exports = __webpack_public_path__ + "img/map.98f92319.svg";